<template>
  <footer class="py-12 px-8 bg-background">
    <div class="container mx-auto">
      <ScrollReveal :delay="300">
        <div class="max-w-7xl mx-auto pt-8 border-t border-primary/10">
          <div class="flex flex-col md:flex-row justify-between items-center gap-4">
            <p class="text-gray-400">© {{ currentYear }} Pixelab. All Rights Reserved.</p>
            <div class="flex items-center gap-8">
              <div class="flex gap-4">
                <router-link
                  to="/privacy-policy"
                  class="text-gray-400 hover:text-transparent hover:bg-gradient-primary hover:bg-clip-text transition-all duration-300"
                  @click="scrollToTop"
                >
                  Privacy Policy
                </router-link>
                <router-link
                  to="/terms-of-service"
                  class="text-gray-400 hover:text-transparent hover:bg-gradient-primary hover:bg-clip-text transition-all duration-300"
                  @click="scrollToTop"
                >
                  Terms of Service
                </router-link>
              </div>
              <div class="flex gap-4">
                <a
                  v-for="(social, index) in socialLinks"
                  :key="index"
                  :href="social.url"
                  target="_blank"
                  rel="noopener noreferrer"
                  class="transform transition-all duration-300 hover:-translate-y-1"
                >
                  <img :src="social.icon" :alt="social.name" class="w-6 h-6" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </ScrollReveal>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue'
import ScrollReveal from './ScrollReveal.vue'

const currentYear = computed(() => new Date().getFullYear())

const scrollToTop = () => {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  })
}

const socialLinks = [
  {
    name: 'Email',
    url: 'mailto:pixelab_team@outlook.com',
    icon: '/images/email-logo.png',
  },
  {
    name: 'Instagram',
    url: 'https://www.instagram.com',
    icon: '/images/ins-log.png',
  },
  {
    name: 'Facebook',
    url: 'https://www.facebook.com',
    icon: '/images/facebook-logo.png',
  },
]
</script>

<style scoped></style>
